import styles from './TeamSection.module.css';

const teamMembers = [
  {
    name: "Louis D'souza",
    role: "Designated Partner",
    quote: "We don't hire resumes. We hire results. You close 1 deal, you earn your seat. That's how real players join the Property Plateau League.",
    image: '/Louis-Dsouza.jpeg'
  },
  {
    name: "Abhishek Pandhare",
    role: "Designated Partner",
    quote: "In a world full of noise, we focus on substance. We don't just list what's available — we shape what gets sold. Our Builder Relations team is not just support; it's the supply engine of Property Plateau.",
    image: '/Abhishek-Pandhare.jpeg'
  }
];

export default function TeamSection() {
  return (
    <section className={styles.teamSection}>
      <div className={styles.teamHeader}>
        <h2 className={styles.sectionTitle}>Who You'll Work With</h2>
        <p className={styles.sectionSubtitle}>A small, fearless, fast-moving team of visionaries, builders, and doers.</p>
      </div>

      {/* Founders in column grid (side by side) */}
      <div className={styles.foundersGrid}>
        {teamMembers.map((member, index) => (
          <div key={index} className={styles.founderCard}>
            <div className={styles.founderImageContainer}>
              <img
                src={member.image}
                alt={member.name}
                className={styles.founderImage}
              />
            </div>
            <div className={styles.founderContent}>
              <h3 className={styles.memberName}>{member.name}</h3>
              <p className={styles.memberRole}>{member.role}</p>
              <blockquote className={styles.memberQuote}>
                "{member.quote}"
              </blockquote>
            </div>
          </div>
        ))}
      </div>

      {/* Three trait cards below */}
      <div className={styles.traitsSection}>
        <h3 className={styles.traitsTitle}>Our Team Culture</h3>
        <div className={styles.traitsGrid}>
          <div className={styles.traitCard}>
            <h4>Visionaries</h4>
            <p>Who think long-term</p>
          </div>
          <div className={styles.traitCard}>
            <h4>Builders</h4>
            <p>Who ship fast</p>
          </div>
          <div className={styles.traitCard}>
            <h4>Dreamers</h4>
            <p>Who execute</p>
          </div>
        </div>
      </div>
    </section>
  );
}